/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpRequest, HttpEvent, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthFacade } from '~console/app/~store/facades/auth.facade';
import { GlobalFacade } from '~console/app/~store/facades/global.facade';
import { UserRole } from '~core/models/auth.models';
import { PageName } from '../models/shared.models';

export function superAdminOrganizationIdInterceptor(
  request: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> {
  const authFacade = inject(AuthFacade);
  const globalFacade = inject(GlobalFacade);
  const currentUser = authFacade.currentUser;
  const pageName = globalFacade.routeData?.data?.pageName as
    | PageName
    | undefined;

  if (
    !currentUser?.organization ||
    (!currentUser.roles.includes(UserRole.ROLE_SUPER_ADMIN) &&
      !currentUser.roles.includes(UserRole.ROLE_ADMIN))
  ) {
    return next(request);
  }

  if (pageName && [PageName.receipts, PageName.dashboard].includes(pageName)) {
    return next(
      request.clone({
        params: request.params.set(
          'organizationNif',
          currentUser.organization.nif
        )
      })
    );
  }

  const whiteListEndPath = ['/partners'];
  if (whiteListEndPath.every(path => !request.url.endsWith(path))) {
    return next(
      request.clone({
        params: request.params.set(
          'organizationId',
          currentUser.organization.id
        )
      })
    );
  }

  return next(request);
}
